export default "__VITE_ASSET__84e04d89__"